import { axiosNodeInstance } from "../../../adapters/axiosInstance";
import { GET_VEHICLE_RECOMMENDATION, GET_VEHICLES } from "./vehicleTypes";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getVehicleRecommendation = createAsyncThunk(GET_VEHICLE_RECOMMENDATION, async (estimateId) => {
    const response = await axiosNodeInstance.get(`/estimate_quotes/vehicle_recommendation?estimateId=${estimateId}`);
    return response.data;
});

export const getVehicles = createAsyncThunk(GET_VEHICLES, async (estimateId) => {
    const response = await axiosNodeInstance.get("/estimate_quotes/vehicles");
    return response.data;
});
